/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q1_QuestionInputs */

const en_faq_q1_question = /** @type {(inputs: Faq_Q1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do I need insurance?`)
};

const fr_faq_q1_question = /** @type {(inputs: Faq_Q1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi ai-je besoin d'une assurance ?`)
};

/**
* | output |
* | --- |
* | "Why do I need insurance?" |
*
* @param {Faq_Q1_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_q1_question = /** @type {((inputs?: Faq_Q1_QuestionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q1_QuestionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q1_question(inputs)
	return fr_faq_q1_question(inputs)
});